<template>
  <div :class="['sui-text-field', wrapperClasses]">
    <input
      ref="refInput"
      v-model="txtField"
      :type="'text'"
      :disabled="disabled"
      :readonly="readonly"
      :title="showTooltip? txtField: null"
      :class="['sui-text-field__input', inputClasses]"
      @input="inputText($event.target.value)"
      @focus="fdpTextFieldFocused"
      @blur="fdpTextFieldBlur"
      @keyup="fdpTextFieldKeyup"
    />
  </div>
</template>

<script>

export default {
  name: 'FdpTextField',
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: String,
      default: null,
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.messages = {
      'MSG_BTN_DEL_ALL' : utils.getMessageById('MSG_BTN_DEL_ALL'),        
      'MSG_BTN_DEL' : utils.getMessageById('MSG_BTN_DEL'),
      'MSG_BTN_CFRM' : utils.getMessageById('MSG_BTN_CFRM'),        
    };
    this.predefinedMasks = {
      date: '####-##-##',
      'range-date': '####-##-##~####-##-##',
    };
    this.allowedMasks = {
      '#': {
        test: char => char.match(/[0-9]/),
        convert: char => char,
      },
    };
  },
  data() {
    return {
      txtField: '',
      realText: '',
      virtualTxtField: '',
      originValue: '',      
      isFocus: false,
      isActive: false,
      clickCancel: false, // X버튼 클릭 여부
    };
  },
  computed: {
    wrapperClasses() {
      return {
        'sui-text-field--focus': this.isFocus,
        'sui-text-field--readonly': this.readonly,
        'sui-text-field--disabled': this.disabled,
        'sui-text-field--number': this.number,
        'sui-keypad--sticky': this.sticky,
        'sui-keypad--small': this.small,
      };
    },
    inputClasses() {
      return {
        'sui-text-field__input--right': !this.readonly && this.mask === 'currency',
      };
    },
  },
  beforeDestroy() {
  },
  mounted() {
    this.setValue(this.value);
  },
  methods: {
    inputText(inputValue) {
      if (!inputValue) {
        this.txtField = '';
        this.realText = '';
        this.emitInput(this.realText);
        return;
      }      

      if (this.mask) {
        this.txtField = this.applyMask(inputValue, this.mask);            
        this.emitInput(String(this.realText));
      }
    },
    resetData() {
      this.inputText(this.originValue);
    },
    emitInput(text) {
      this.$emit('input', text);
    },
    onlyNums(text) {
      let ret = '';
      for (let i = 0; i < text.length; i += 1) {
        if (this.allowedMasks['#'].test(text[i])) { ret += text[i]; }
      }
      return ret;
    },
    applyMask(text, mask) {
      if (mask === 'decimal') {
        if (text.substring(0, text.length - 1).includes('.')) {
          const textDecimalArr = text.split('.');
          text = `${textDecimalArr[0]}.`;
          for (let i = 1; i < textDecimalArr.length; i += 1) {
            text += textDecimalArr[i];
          }
        }
      }
      const predefined = this.predefinedMasks[mask];
      const masks = predefined || mask;
      const masked = masks.split('');
      let textIdx = 0;
      let maskIdx = 0;
      let maskedText = '';
      this.realText = '';
      while (maskIdx < masked.length && textIdx < text.length) {
        let m = masked[maskIdx];
        const c = text[textIdx];
        if (this.isMask(m)) {
          if (this.allowedMasks[m].test(c)) {
            textIdx += 1;
            maskIdx += 1;
            this.realText += c;
            maskedText += this.allowedMasks[m].convert(c);
          } else {
            return maskedText;
          }
        } else {
          if (m === '[') {
            maskIdx += 1;
            m = masked[maskIdx];
          }
          if (c === m) {
            textIdx += 1;
          }
          maskIdx += 1;
          maskedText += m;
        }
      }
      return maskedText;
    },
    isMask(mask) {
      return Object.prototype.hasOwnProperty.call(this.allowedMasks, mask);
    },
    clearInputValue() {
      this.inputText('');
      this.$emit("clear-input");
    },
    toggleIcon() {
      if (this.fixedIcon) {
        this.$emit('click');
      }
    },
    numberWithCommas(number, comma = ',') {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, comma);
    },
    activate() {
      if (!this.disabled) {
        this.$refs.refInput.focus();
      }      
    },
    setFocus() {
      this.$refs.refInput.focus();
    },
    fdpTextFieldKeyup(event) {
      if (event.keyCode === 13 && !this.preventEnterBlur) {
        this.$refs.refInput.blur();
      }

      this.$emit('keyup', event);
    },
    fdpTextFieldFocused(event) {
      if (this.isFocus) return;
      this.isFocus = true;
      this.$emit('focus', event);
    },
    fdpTextFieldBlur(event) {
      this.isFocus = false;
      if (typeof this.txtField === 'string' && this.trim) {
        this.inputText(this.txtField.trim());
      }
      this.$emit('blur', event, this.clickCancel);
    },
    /* 숫자인지 체크 */
    checkNumber(targetText) {
      const regex = /^[0-9]*$/;
      return regex.test(Number(targetText));
    },
    setValue(value) {
      this.inputText(value);
    }
  },
};
</script>

<style>
</style>
